<!--
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2023-10-23 15:30:15
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/App.vue
 -->
<template>
  <div id="app"><router-view /></div>
</template>
<script>
export default {
  name: 'App',
  created() {
    // // 获取服务器时间
    // this.API.workbench.getServerTime().then(res => {
    //     let serverTime = {
    //         date: res.data[0],
    //         timestamp: res.data[1]
    //     }
    //     window.localStorage.setItem('serverTime', JSON.stringify(serverTime))
    //     // console.log("aaaa", this.$store)
    // })
  },
  mounted() {
    // 获取服务器时间
    // this.API.workbench.getServerTime().then(res => {
    //     let serverTime = {
    //         date: res.data[0],
    //         timestamp: res.data[1]
    //     }
    //     window.localStorage.setItem('serverTime', JSON.stringify(serverTime))
    //     // console.log("aaaa", this.$store)
    // })
  }
}
</script>
<style lang="scss">
@import '~@assets/style/index.scss';

.mouse-pointer:hover {
    cursor: pointer;
}

//全局el-table表头和表格对齐
.el-table--border th.gutter:last-of-type {
  display: block !important;
  width: 17px !important;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
  background-color: #8487879e;
}

//首先隐藏原来的滚动轴阴影，然后自己加阴影
.el-table__fixed,
.el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed::before,
.el-table__fixed-right::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: unset;
  z-index: 4;
}

.scanToLoad {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue